import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './ProfilModal.css';
import { API_ENDPOINTS } from '../config/api';

const ProfilModal = ({ isOpen, onClose, akademisyenId }) => {
  const { t } = useTranslation();
  const [profilData, setProfilData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && akademisyenId) {
      fetchProfilData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, akademisyenId]);

  const fetchProfilData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(API_ENDPOINTS.AKADEMISYEN_GUNCEL_BY_ID(akademisyenId));
      const data = await response.json();

      if (response.ok) {
        setProfilData(data);
      } else {
        setError(data.error || t('profil.connectionError'));
      }
    } catch (err) {
      setError(t('profil.connectionError'));
      console.error('Profil verisi alınırken hata:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="profil-modal-overlay" onClick={onClose}>
      <div className="profil-modal" onClick={(e) => e.stopPropagation()}>
        <div className="profil-modal-header">
          <h2>{t('profil.title')}</h2>
          <button className="profil-modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="profil-modal-content">
          {loading && (
            <div className="profil-loading">
              <div className="loading-spinner"></div>
              <p>{t('profil.loading')}</p>
            </div>
          )}

          {error && (
            <div className="profil-error">
              <p>❌ {error}</p>
            </div>
          )}

          {profilData && !loading && (
            <div className="profil-info">
              <div className="profil-section">
                <h3>{t('profil.personalInfo')}</h3>
                <div className="profil-field">
                  <label>{t('profil.titleLabel')}</label>
                  <span>{profilData.title || t('profil.notSpecified')}</span>
                </div>
                <div className="profil-field">
                  <label>{t('profil.name')}</label>
                  <span>{profilData.name || t('profil.notSpecified')}</span>
                </div>
                <div className="profil-field">
                  <label>{t('profil.surname')}</label>
                  <span>{profilData.surname || t('profil.notSpecified')}</span>
                </div>
                <div className="profil-field">
                  <label>{t('profil.email')}</label>
                  <span>{profilData.email || t('profil.notSpecified')}</span>
                </div>
              </div>

              <div className="profil-section">
                <h3>{t('profil.academicInfo')}</h3>
                <div className="profil-field">
                  <label>{t('profil.faculty')}</label>
                  <span>{profilData.faculty || t('profil.notSpecified')}</span>
                </div>
                <div className="profil-field">
                  <label>{t('profil.program')}</label>
                  <span>{profilData.program || t('profil.notSpecified')}</span>
                </div>
              </div>

              <div className="profil-section">
                <h3>{t('profil.accountInfo')}</h3>
                <div className="profil-field">
                  <label>{t('profil.password')}</label>
                  <span className="password-field">
                    {profilData.password ? '••••••••' : t('profil.notSpecified')}
                  </span>
                </div>
                <div className="profil-field">
                  <label>{t('profil.registrationDate')}</label>
                  <span>
                    {profilData.created_at ?
                      // Çeviri anahtarı eksikse i18next anahtarın kendisini ("common.locale")
                      // döndürür; geçersiz dil etiketi toLocaleDateString'i çökertmesin.
                      new Date(profilData.created_at).toLocaleDateString(
                        (() => { const l = t('common.locale'); return (l && !l.includes('.')) ? l : undefined; })()
                      ) :
                      t('profil.notSpecified')
                    }
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfilModal;
